import "oc-interaction/events/pantouch.js";
import Dialogs from "./Dialogs.js";
import HBS from "../hbs/HBS.js";
import Commons from "oc-commons/Commons";

// see http://www.jqueryscript.net/other/jQuery-Bootstrap-Based-Toast-Notification-Plugin-toaster.html

function removeOnHide(dialog) {
    dialog.on('hidden.bs.modal', function () {
        $(this).data('bs.modal', null);
        dialog.remove();
    });
}


let container = 'body';

Dialogs.setContainer=(target)=>{
    container=target;
};

Dialogs.getContainer=()=>{
    return container;
};

Dialogs.showToast = (message, duration=3000) => {
    const toast = $(HBS('oc-ui/dialogs/toast.hbs')({message}));
    toast.hide();
    $(container).append(toast);
    toast.fadeIn();
    const end = ()=>{
        toast.fadeOut(()=>toast.remove());
    };
    if (Number.isFinite(duration)) {
        _.delay(end, duration);
    }
    return {hide: end};
};

Dialogs.showToastWithoutFading = (message, duration=3000) => { //webXr
    const toast = $(HBS('oc-ui/dialogs/toast.hbs')({message}));
    $(container).append(toast);
    const end = ()=>{
        toast.remove();
    };
    if (Number.isFinite(duration)) {
        _.delay(end, duration);
    }
    return {hide: end};
};


Dialogs.showWarning = (message) => {
    const a = HBS('oc-ui/dialogs/warning.hbs')({message});
    const dialog = $(a);
    $(container).append(dialog);
    dialog.modal('show');
    removeOnHide(dialog);
    return {hide: () => {
        dialog.modal('hide');
    }};
};

Dialogs.showError = (message) => {
    const dialog = $(HBS('oc-ui/dialogs/error.hbs')({message}));
    $(container).append(dialog);
    dialog.modal({
        backdrop: false,
        keyboard: false
    });
    removeOnHide(dialog);
    return {hide: () => {
        dialog.modal('hide');
    }};
};

Dialogs.showWaiting = (message) => {
    const dialog = $(HBS('oc-ui/dialogs/waiting.hbs')({message}));
    $(container).append(dialog);
    dialog.modal({
      backdrop: 'static',
      keyboard: false
    });
    removeOnHide(dialog);
    return {hide: () => {
        dialog.modal('hide');
    }};
};

// buttonAndActionList ist eine Liste von {label: string, primary: boolean, action: callback }
Dialogs.askQuestion = (message, buttonAndActionList) => {
    const dialog = $(HBS('oc-ui/dialogs/question.hbs')({message}));
    const footer = $('.modal-footer',dialog);
    buttonAndActionList.forEach(b=>{
        b.class_ = b.class_ || (b.primary?'btn-primary':'');
        const button = $(HBS('oc-ui/dialogs/questionButton.hbs')(b));
        button.on('tap',()=>{
            hide();
            if (b.action) {
                b.action();
            }
        });
        footer.append(button);
    });

    function hide() {
        dialog.modal('hide');
    }

    dialog.modal('show');
    removeOnHide(dialog);
    return {hide};
};

Dialogs.showHtml = (htmlElement, options) => {
    options=Commons.defaultsDeepSafe({},options);
    const dialog = $(HBS('oc-ui/dialogs/custom.hbs')());
    $('.modal-content',dialog).append(htmlElement);
    //$(container).append(dialog);
    dialog.modal({
        backdrop: 'static',
        keyboard: false
    });
    removeOnHide(dialog);
    if (options.onShow) options.onShow(dialog);
    function hide() {
        dialog.modal('hide');
    }
    return {hide};
};

export default Dialogs;
